

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchLeaveTypes } from "../../redux/actions/leaveTypeActions";
import EditLeaveTypeModal from "../../pages/Leave Management/LeaveTypeEditModal";
import theme from "../../components/shared/theme";
import { thStyle, tdStyle } from "../../components/shared/themeStyles";

const LeaveTypes = () => {
  const dispatch = useDispatch();
  const { leaveTypes, loading, error } = useSelector((state) => state.leaveType || {});
  const [selectedLeaveType, setSelectedLeaveType] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    dispatch(fetchLeaveTypes());
  }, [dispatch]);

  const handleEdit = (leaveType) => {
    setSelectedLeaveType(leaveType);
    setShowModal(true);
  };

  return (
    <div style={{ backgroundColor: theme.colors.background, padding: theme.spacing.md, minHeight: "100vh" }}>
      <h1 style={{ fontSize: theme.font.size["2xl"], fontWeight: theme.font.weight.bold, marginBottom: theme.spacing.md }}>
        Leave Types
      </h1>

      {loading ? (
        <p>Loading leave types...</p>
      ) : error ? (
        <div style={{
          backgroundColor: theme.colors.dangerLight,
          border: `1px solid ${theme.colors.danger}`,
          color: theme.colors.dangerText,
          padding: theme.spacing.sm,
          borderRadius: theme.radius.md,
        }}>
          Error: {error}
        </div>
      ) : (
        <div className="overflow-x-auto bg-white rounded-lg shadow-lg">
          <table className="min-w-[600px] w-full text-sm text-left">
            <thead style={{ backgroundColor: theme.colors.grayDark, color: "white" }}>
              <tr>
                <th style={thStyle}>#</th>
                <th style={thStyle}>Name</th>
                <th style={thStyle}>Description</th>
                <th style={thStyle}>Status</th>
                <th style={thStyle}>Policies</th>
                <th style={thStyle}>Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {leaveTypes.map((leave, index) => (
                <tr key={leave.id || index} className="hover:bg-gray-50">
                  <td style={tdStyle}>{index + 1}</td>
                  <td style={tdStyle}>{leave.name}</td>
                  <td style={tdStyle}>{leave.description}</td>
                  <td style={tdStyle}>{leave.status}</td>
                  <td style={tdStyle}>
                    <ul className="list-disc pl-4">
                      {leave.policies?.map((p, i) => (
                        <li key={i}>{p.designation}: {p.total_leaves} days</li>
                      ))}
                    </ul>
                  </td>
                  <td style={tdStyle}>
                    <button
                      onClick={() => handleEdit(leave)}
                      className="px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600"
                    >
                      Edit
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {showModal && selectedLeaveType && (
        <EditLeaveTypeModal
          leaveType={selectedLeaveType}
          onClose={() => {
            setShowModal(false);
            setSelectedLeaveType(null);
          }}
        />
      )}
    </div>
  );
};

export default LeaveTypes;
